import styled from "@emotion/styled";


export const ClickableWrapper = styled.div`
    cursor: pointer;
   
`;

export const AnchorWrapper = styled.a`
  display: inline-block;
`;

export const BasicButton = styled.button`
 background-color: transparent;
 border: 0;
 &:hover, &:focus &:active {
  outline : 0;
 }
 
`;
